import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { UtilityService } from "@irb-common/services/utility.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private util: UtilityService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.endsWith("/getEAT")) {
      return next.handle(req);
    }
    
    const authToken = window.atob(window.sessionStorage.getItem("IRB_AUTH_TOKEN"));
    const gatewayURL = window.atob(window.sessionStorage.getItem("IRB_GATEWAY_URL"));
    const env = this.util.getEnv();

    // SAC Context API
    if (req.url.includes("ria.ASCoreExperience/v1/api/context")) {
      const sacReq = req.clone({
        setHeaders: {
          "Accept": "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
          "Authorization": authToken,
          "Schwab-Client-CorrelId": this.util.generateSchwabUUID(),
          "Schwab-Client-AppId": "AD00007808",
          "Schwab-Resource-Version": "1",
          "Schwab-Client-Channel": "S3",
          "Schwab-Env": env,
          "Schwab-RRBus-PilotRollout": env,
          "Schwab-Client-Env": env
        }
      });
      return next.handle(sacReq);
    }

    //JFK routing
    let modURL = req.url;
    let baseURL = (window.location.hostname !== "localhost") ? gatewayURL : "https://jfk.dev.schwab.com/api";

    if (window.location.hostname !== "localhost") {
      if(modURL.includes("/irebalone/")) {
        modURL = modURL.replace('/irebalone/', baseURL + '/uddi:schwab.com:service:sch.core.ria.iRebalNextGen/v1/iRebalNG/');
      } else if(modURL.includes("irebalone/")) {
        modURL = modURL.replace('irebalone/', baseURL + '/uddi:schwab.com:service:sch.core.ria.iRebalNextGen/v1/iRebalNG/');
      } else if(modURL.includes("/mmc/")) {
        modURL = modURL.replace('/mmc/', baseURL + '/uddi:schwab.com:service:sch.core.ria.iRebalMMC/v1/MMC/mmc/');
      } else if(modURL.includes("/irebal-rprt/")) {
        modURL = modURL.replace('/irebal-rprt/', baseURL + '/uddi:schwab.com:service:sch.core.ria.iRebalAllocationReport/v1/AllocationReport/irebal-rprt/');
      } else if(modURL.includes("/irb-cash-rprt/")) {
        modURL = modURL.replace('/irb-cash-rprt/', baseURL + '/uddi:schwab.com:service:sch.core.ria.iRebalCashReport/v1/CashReport/irb-cash-rprt/');
      } else if(modURL.includes("/irebalAuthService/")) {
        modURL = modURL.replace('/irebalAuthService/', baseURL + '/uddi:schwab.com:service:sch.core.ria.iRebalAuthorization/v1/iRebalAuthZ/');
      } else if(modURL.includes("/model-market-service/")) {
        modURL = modURL.replace('/model-market-service/', baseURL + '/uddi:schwab.com:service:sch.core.ria.iRebalMMC/v1/ModelMarket/mmc/');
      } else if(modURL.includes("/irebal-security/")) {
        modURL = modURL.replace('/irebal-security/', baseURL + '/uddi:schwab.com:service:sch.core.ria.iRebalSecurities/v1/Security/');
      }
    }

    // Clone the request and set the new header
    const authReq = req.clone({
      url:modURL,
      setHeaders: {
        "Accept": "application/json, text/plain, */*",
        "Schwab-Client-CorrelId": this.util.generateSchwabUUID(),
        "Schwab-Resource-Version": "1",
        "Schwab-Client-AppId": "AD00007808",
        "Referrer-Policy": "no-referrer",
        "Cache-Control": 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        "Vary": "Origin",
        "Pragma": "no-cache",
        "Expires": "Sat, 01 Jan 2000 00:00:00 GMT",
        "Schwab-Gateway-Scope": "AdvisorCenter",
        "Authorization": authToken,
        "Schwab-Env": env
      },
    });

    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
